<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component';
    import { AlternativeEditorAttributeFieldReadModel } from "@Alternatives/Alternatives/Domain/readmodels";
    import { ValidationError } from "@common/types";

    @Component({
        props: {
            propF: { type: Object, required: true },
            propErrors: { type: Array, required: true },
        }
    })
    export default class TextInputSingleValue extends Vue
    {
        get f(): AlternativeEditorAttributeFieldReadModel { return this.$props.propF as AlternativeEditorAttributeFieldReadModel; }
        get errors(): ValidationError[] { return this.$props.propErrors as ValidationError[]; }

        get error() { return this.errors?.find(error => error.Context.startsWith(`AlternativeAttribute:${this.f.Id}`))?.Error; }

        get tooltipText() 
        {
            let tooltip = 'Please enter text';
            if (this.f.IsRequired) tooltip += ', required';
            if (this.f.MinLength) tooltip += `, minimum length: ${this.f.MinLength}`;
            if (this.f.MaxLength) tooltip += `, maximum length: ${this.f.MaxLength}`;
            return tooltip;
        }        
    }
</script>

<template>
    <div class="form-group">
        <label>
            <span v-if="f.IsRequired" style="color: red;">*</span> {{f.Name}}
        </label>

        <input type="text" class="form-control" placeholder="Enter text..." :title="tooltipText"
               v-model.trim="f.Value"
               :required="f.IsRequired === true"
               :readonly="f.IsReadonly === true"
               :minlength="f.MinLength != null ? f.MinLength : null"
               :maxlength="f.MaxLength != null ? f.MaxLength : null" />

        <div class="error">{{error}}</div>
        <small class="form-text text-muted" v-if="f.Description">{{f.Description}}</small>
    </div>
</template>